import React, { useState } from 'react';
import Slider from '../../../../../../../components/utils/Slider/Slider';
import Img from '../../../../../../../components/Img/Img';
import { WidgetItemEvent } from '../../../../../../../types/widget';
import notFoundImg from '../../../../../../../static/images/common/not-found-img.png';
import { EventWidgetSwipeLayoutStyle } from './style';

interface EventWidgetSwipeLayoutProps {
  list?: WidgetItemEvent[];
}

const EventWidgetSwipeLayout = (props: EventWidgetSwipeLayoutProps) => {
  const { list } = props;

  const [swipeIndex, setSwipeIndex] = useState(0);

  const handleSwipe = (oldIndex: number, newIndex: number) => {
    setSwipeIndex(newIndex);
  };

  return (
    <EventWidgetSwipeLayoutStyle>
      <Slider
        list={list}
        arrows={false}
        dots={false}
        beforeChange={handleSwipe}
        infinite={false}
        item={(eventItem: WidgetItemEvent) => (
          <Img clickAble={false} src={eventItem.mobileImage?.[0]?.url || notFoundImg} />
        )}
      />

      <div className="number-indicator-wrap">
        <span className="current">{swipeIndex + 1}/</span>
        <span className="entire">{list?.length || 0}</span>
      </div>
    </EventWidgetSwipeLayoutStyle>
  );
};

export default EventWidgetSwipeLayout;
